import React from "react";
import { Table, Checkbox, Tag } from "antd";
import { useTranslation } from "react-i18next";
import PartnerLink from "./PartnerLink";

const PartnerFilterTable = ({ 
  partners, 
  checkedPartners, 
  onPartnerCheck 
}) => {
  const { t } = useTranslation();

  const getStateColor = (state) => {
    switch (state) {
      case 'ready': return 'green';
      case 'stand': return 'blue';
      case 'waiting': return 'gold';
      case 'inferior': return 'red';
      case 'disinterested': return 'red';
      default: return 'default';
    }
  };

  const getStateName = (state) => {
    if (!state) return t('common.empty');
    const states = t('partners.states', { returnObjects: true });
    return states[state] || state;
  };

  const columns = [
    {
      title: '',
      key: 'checkbox',
      width: 50,
      render: (_, record) => (
        <Checkbox
          checked={checkedPartners[record.id] || false}
          onChange={(e) => onPartnerCheck(record.id, e.target.checked)}
        />
      ),
    },
    {
      title: t("cleanings.fullName"),
      key: 'name',
      render: (_, record) => <PartnerLink partner={record} />,
    },
    {
      title: t("common.partnerLocation"),
      key: 'location',
      render: (_, record) => {
        const locations = [];

        if (record.preferred_locations && record.preferred_locations.length > 0) {
          record.preferred_locations.forEach(loc => {
            const cityName = loc.city_branch?.name || loc.city_branch?.name_eng;
            const locationName = loc.city_branch_location?.name || loc.city_branch_location?.name_eng;
            
            if (locationName) {
              locations.push(locationName);
            } else if (cityName) {
              locations.push(cityName);
            }
          });
        } else if (record.city_branches && record.city_branches.length > 0) {
          record.city_branches.forEach(city => {
            const cityName = city.name || city.name_eng;
            if (cityName) {
              locations.push(cityName);
            }
          });
        }
        
        return locations.length > 0 ? locations.join(", ") : (
          <span style={{ color: '#1890ff', fontStyle: 'italic' }}>
            {t("common.empty")}
          </span>
        );
      },
    },
    {
      title: t("common.partnerState"),
      key: 'state',
      render: (_, record) => {
        if (!record.state) return (
          <span style={{ color: '#1890ff', fontStyle: 'italic' }}>
            {t("common.empty")}
          </span>
        );
        return (
          <Tag color={getStateColor(record.state)}>
            {getStateName(record.state)}
          </Tag>
        );
      },
    },
  ];

  return (
    <Table
      dataSource={partners}
      rowKey="id"
      pagination={false}
      size="small"
      scroll={{ y: 400 }}
      columns={columns}
    />
  );
};

export default PartnerFilterTable;
